import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Disinvestment } from '../domain/data';
import { DisinvestmentInterface } from '../../core';
import { Serializer } from '../client/helpers/serializer/serializer';

@Injectable({
    providedIn: 'root',
})
export class DisinvestmentResolver implements Resolve<DisinvestmentInterface> {
    constructor(private router: Router, private serializer: Serializer) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DisinvestmentInterface> {
        if (!this.router.getCurrentNavigation()?.extras.state.disinvestment) {
            throw new Error('Disinvestment not found');
        }

        return this.serializer.fromJson(this.router.getCurrentNavigation()?.extras.state.disinvestment, Disinvestment);
    }
}
